const INITIAL_STATE = {
  data: {},
  errors: {},
      
}
const UpdatePriceMatrix = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'UPDATE_STANDARD_CLEANING_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'UPDATE_STANDARD_CLEANING_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
      
export default UpdatePriceMatrix;